import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from 'moment';
import { Environment } from '../../../shared/environment';
import { IgetImpressaoNota } from '../../../shared/services/api/vendas/pedidonota/PedidoNota';

async function PDFPedidoAgada(dados: IgetImpressaoNota) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }
  const imageUrl = Environment.URL_IMGFABRICA + dados.logo || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);
  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }
  const TProdutos = dados.itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);
  const Ttotal = dados.itens.reduce((acc, item) => acc + (item.total || 0), 0);
  const TRegistros = dados.itens.length;

  const rows = dados.itens.map((row) => {
    return [
      { text: row.codfabrica, fontSize: 8, border: [false, false, false, false] },
      { text: row.descricao, fontSize: 8, border: [false, false, false, false] },
      {
        table: {
          widths: [40],
          body: [
            [{
              text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.quantidade),
              alignment: 'center', fontSize: 8,
            }
            ],
          ]
        },
        border: [false, false, false, false]
      },
      { text: row.un, border: [false, false, false, false] },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.preco),
        alignment: 'right', border: [false, false, false, false], bold: true, fontSize: 9
      },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.total),
        alignment: 'right', border: [false, false, false, false], bold: true, fontSize: 9
      },
    ]
  });
  const documentDefinition: any = {
    pageMargins: [20, 5, 20, 20],
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [90, 420],
          body: [
            [
              {
                margin: [0, 5, 0, 0],
                image: imageData,
                width: 90,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [250, 30, 120],
                  body: [
                    [
                      { text: 'AGADA SEMIJOIAS LTDA', style: 'header', fontSize: 12, alignment: 'center', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: 'Emissao:' + moment(dados.dataoperacao).format('DD/MM/YYYY'), border: [false, false, false, false], fontSize: 8, },
                    ],
                    [
                      { text: 'RUA IATA ANDERSON ALVES DE OLIVEIRA - 140 - 0', border: [false, false, false, false], fontSize: 9, },
                      { text: '', border: [false, false, false, false], fontSize: 8, },
                      { text: '', border: [false, false, false, false], fontSize: 8 },
                    ],
                    [
                      { text: 'ITABAIANA - SE TEL: (79) 9 9919-0340', fontSize: 9, border: [false, false, false, false] },
                      { text: 'agdasemijoias@hotmail.com', colSpan: 2, fontSize: 9, border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                    ],
                  ],
                }
              }
            ],
            [
              { text: '  ', fontSize: 3, border: [true, true, false, true] },
              { text: ' ', fontSize: 3, border: [false, true, true, true] },
            ],
          ]
        }
      },
      {
        border: [false, false, false, false],
        table: {
          widths: [350, 30, 100],
          body: [
            [
              { text: 'PEDIDO DE VENDA', colSpan: 3, fontSize: 10, bold: true, alignment: 'center', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              { text: 'Documento:        ' + dados.numero, fontSize: 10, bold: true, alignment: 'center', border: [false, false, false, false] },
              { text: 'Valor', alignment: 'right', fontSize: 10, border: [false, false, false, false] },
              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dados.valor), bold: true, alignment: 'left', fontSize: 10, border: [false, false, false, false] },
            ],
          ],

        }
      },
      {
        border: [false, false, false, false],
        table: {
          widths: [70, 190, 80, 50],
          body: [
            [
              { text: 'Data:  ' + moment(dados.dataoperacao).format('DD/MM/YYYY'), colSpan: 2, fontSize: 7, bold: true, border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              { text: 'Razão Social:', fontSize: 8, bold: true, border: [false, false, false, false] },
              { text: dados.nome, fontSize: 8, border: [false, false, false, false] },
              { text: 'Vendedor', alignment: 'right', fontSize: 8, border: [false, false, false, false] },
              {
                text: 'Claudio',
                fontSize: 10,
                bold: true,
                border: [false, false, false, false]
              },
            ],
            [
              { text: 'N. Fantasia:', fontSize: 8, bold: true, border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              { text: 'CNPJ:', fontSize: 8, bold: true, border: [false, false, false, false] },
              { text: dados.cpf, fontSize: 8, border: [false, false, false, false] },
              { text: 'Fechamento', alignment: 'right', fontSize: 8, border: [false, false, false, false] },
              { text: 'Leneker', fontSize: 8, border: [false, false, false, false] },
            ],
            [
              { text: 'Endereço:', fontSize: 8, bold: true, border: [false, false, false, false] },
              { text: dados.endereco, fontSize: 8, border: [false, false, false, false] },
              { text: 'Insc Est:', alignment: 'right', fontSize: 8, border: [false, false, false, false] },
              { text: dados.rg, fontSize: 8, border: [false, false, false, false] },
            ],
            [
              { text: 'CEP:', fontSize: 8, bold: true, border: [false, false, false, false] },
              { text: dados.cep, fontSize: 8, border: [false, false, false, false] },
              { text: 'Cidade', alignment: 'right', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
            ],
            [
              { text: 'Fone:', fontSize: 7, bold: true, border: [false, false, false, false] },
              { text: dados.celular, fontSize: 8, border: [false, false, false, false] },
              { text: 'UF', alignment: 'right', fontSize: 8, border: [false, false, false, false] },
              { text: dados.uf, fontSize: 8, border: [false, false, false, false] },
            ],
            [
              { text: 'Ponto Ref', fontSize: 7, bold: true, border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              { text: 'Observações:', fontSize: 7, bold: true, border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
          ],
        }
      },
      {
        table: {
          widths: [50, 215, 50, 30, 60, 70],
          body: [
            [
              { text: 'codigo', border: [false, false, false, true], fontSize: 9 },
              { text: 'Descrião', border: [false, false, false, true], fontSize: 9 },
              { text: 'Quantidade', alignment: 'center', border: [false, false, false, true], fontSize: 9 },
              { text: 'Volune', alignment: 'center', border: [false, false, false, true], fontSize: 9 },
              { text: 'Vlr Unitario', alignment: 'right', border: [false, false, false, true], fontSize: 9 },
              { text: 'Vlr Total', alignment: 'right', border: [false, false, false, true], fontSize: 9 },
            ],
            ...rows,
          ]
        },
      },
      {
        table: {
          widths: [215, 55, 40, 105, 70],
          body: [
            [
              { text: 'Q. Registros:  ' + TRegistros, border: [false, true, false, false], fontSize: 9 },
              { text: 'Q. Produtos: ', alignment: 'left', border: [false, true, false, false], fontSize: 9 },
              { text: TProdutos, alignment: 'center', fontSize: 9 },
              { text: 'Total Bruto', alignment: 'right', border: [false, true, false, false], fontSize: 9 },
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Ttotal),
                fontSize: 9, alignment: 'right', border: [false, true, false, false]
              },
            ],
            [
              { text: '', border: [false, false, false, false], fontSize: 9 },
              { text: '', alignment: 'left', border: [false, false, false, false], fontSize: 9 },
              { text: '', border: [false, false, false, false], alignment: 'center', fontSize: 9 },
              { text: 'Total Des:', alignment: 'right', border: [false, false, false, false], fontSize: 9 },
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0),
                fontSize: 9, alignment: 'right', border: [false, false, false, false]
              },
            ],
            [
              { text: '', border: [false, false, false, false], fontSize: 9 },
              { text: '', alignment: 'left', border: [false, false, false, false], fontSize: 9 },
              { text: '', border: [false, false, false, false], alignment: 'center', fontSize: 9 },
              { text: 'Total', alignment: 'right', border: [false, false, false, false], fontSize: 9 },
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0),
                fontSize: 9, alignment: 'right', border: [false, false, false, false]
              },
            ],
          ],
        },
      },
      {
        table: {
          widths: [100, 50],
          body: [
            [
              { text: 'Numero\n' + dados.numero, border: [false, true, false, false], fontSize: 9 },
              { text: 'Valor\n' + Ttotal, alignment: 'center', border: [false, true, false, false], fontSize: 9 },
            ],
          ],
        },
      },
    ],
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFPedidoAgada;